import { render, staticRenderFns } from "./PaddingTopBottomIcon.vue?vue&type=template&id=6b722e32&"
import script from "./PaddingTopBottomIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingTopBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports